import React from 'react'
import './commercial-auto-insurance.scss'
import {
    Hero, MainHeading,
    Breadcrumb, CommonTabs,
    SentryCard, Plans,
    NewsCard, SuccessStories,
    FindAgent,
    PageHeaderIntro
} from '../../../../components';
import { images } from "../../../../utils/customFn";
import { Container } from 'react-bootstrap';

const CommercialAutoInsurance = () => {
    const breadcrumbs = [
        { label: "Sentry Insurance home", link: "/" },
        { label: "What we offer", link: "/what-we-offer" },
        { label: "Insurance products", link: "/what-we-offer/insurance-products" },
        { label: "Business auto insurance", link: "/what-we-offer/insurance-products/business-auto-insurance" },
        { label: "Commercial auto insurance", link: "/what-we-offer/insurance-products/business-auto-insurance/commercial-auto-insurance" },
    ];

    const activeTabId = "difference";

    const tabsData = [
        {
            id: "difference",
            href: "#/",
            label: "The Sentry difference",
        },
        {
            id: "coverages",
            href: "#/",
            label: "Commercial auto insurance products",
        },
        {
            id: "help",
            href: "#/",
            label: "Who we've helped",
        },
    ];

    const sectrydata = {
        banner: images['two_business_people_looking_at_tablet.avif'],
        heading: 'The Sentry difference',
        subheading: 'Different drivers—different coverages',
        para: 'We’ll work with you to determine what liability insurance coverage is appropriate for your organization. Our goal is to help make sure you’re protected from the actual exposures and risks your business faces.',
        sideheading: 'The right coverage for your business',
        sidepara: 'We draw on our insurance experience and leverage our industry knowledge to help you protect your business and your future.',
        sideImg: images['boots_Blue.svg']
    }
    const plansData = {
        blue_heading: 'We tailor our products to your business',
        blue_para: 'Just as individual drivers have varying personal auto insurance coverages, your commercial auto policy shouldn’t be the same as every other business auto policy. Whether you need standard coverages like collision, comprehensive, and liability, or you need something extra, we’ll work with you to help determine commercial auto coverage for your business.',
        purple_icon: images['Icon_of_two_green_birds.svg'],
        purple_heading: 'Claims made easier',
        purple_para: "We’re here for you 24/7 when you need to file a claim.",
    }
    const NewsCardData = [
        {
            id: 1,
            title: 'Commercial auto insurance',
            description:
                'We have the 401(k) and other retirement plan options and services to help you and your employees plan for retirement.',
            linkUrl: '',
            linkText: 'More about commercial auto insurance >',
        },
        {
            id: 2,
            title: 'Dealership auto coverage',
            description: 'Running a business comes with uncertainties. Protect yourself from the unknown with business liability coverage.',
            linkUrl: '/',
            linkText: 'More about dealership auto coverage >',
        },
        {
            id: 3,
            title: 'Commercial auto liability',
            description:
                'Protect your profits and property from the unexpected during a construction or renovation project.',
            linkUrl: '/',
            linkText: 'More about commercial auto liability >',
        },

    ];
    const HeaderData = [
        {
            image: images['passenger-giving-directions-to-driver.svg'],
            para: 'Auto accidents happen—sometimes even when we’ve done nothing wrong. If your customers or employees drive as part of your day-to-day business activities, we have commercial auto insurance products to cover your business and your employees if an accident does happen. Our flexible auto coverage options will also help protect any vehicles you lease, rent, or own for business use.',
        },
    ];
    return (
        <>
            <div className='commercial-auto-insurance'>
                {/* hero section */}
                <Hero img={images["White_commercial_vehicles_parked.avif"]} />
                <Container>
                    {/* Breadcrumb */}
                    <Breadcrumb crumbs={breadcrumbs} />
                    {/* heading  */}
                    <MainHeading title="Commercial auto insurance" showshare={false} />
                    {/* Tabs */}
                    <CommonTabs tabs={tabsData} activeTab={activeTabId} />

                    {/* Header intro section */}
                    <PageHeaderIntro Data={HeaderData} heading="" />

                    {/* the sentry card */}
                    {/* <SentryCard data={sectrydata} /> */}
                    {/* Plans section */}
                    <div className='the-sentry-card'>
                      <h1>The Sentry difference</h1>
                      <Plans data={plansData} />
                    </div>
                    {/* news card section */}
                    <NewsCard Title="Commercial auto insurance products" CardData={NewsCardData} showNavLink={false} subTitle="PRODUCTS" />
                    {/* success stories */}
                    <SuccessStories showSeemore={true} />
                    {/* news  */}
                    <NewsCard Title="News and resources" CardData={NewsCardData} showNavLink={false} subTitle="GUIDES" />
                    <FindAgent />
                </Container>
            </div>
        </>
    )
}

export default CommercialAutoInsurance;